// This software or document includes material copied from or derived from
// W3C Software and Document License
// (https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/)
// Copyright © 2023  World Wide Web Consortium
// (https://www.w3.org/Consortium/Legal/2023/software-license.html)
<template>
  <div>
    <label :id='this.name + "-label"' :for="this.name +'-select'" class="combo-label">{{this.display}}</label>
    <select :id="this.name +'-select'" @change="selectOption" :class="['select-picker', { 'is-error': this.showErrorMessage }]">
      <option v-for="(option, index) in options" :key="index" :value="option">{{ option }}</option>
    </select>
    <div class="err-msg" v-if="this.showErrorMessage">{{ this.errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'CustomSelectNew',
  props: {
    value: {
      type: [String, Object, Array, Number],
      default: null
    },
    required: { // violates a rule if input is not selected with a value
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    name: { // this is for use in creating lowercase aria labels
      type: String,
      required: true
    },
    display: { // this is for use in displayed information
      type: String,
      required: true
    },
    items: { // array of intended dropdown options. displays 0th item as default
      type: Array,
      required: true
    }
  },
  computed: {
    validationRules () {
      const rules = [...this.rules]
      if (this.required) {
        rules.push((value) => !!value || 'Required')
      }
      return rules
    }
  },
  data () {
    return {
      open: false,
      selectedOption: null,
      options: [],
      activeIndex: 0,
      searchTimeout: null,
      idBase: '',
      input: this.$attrs.value,
      showErrorMessage: false,
      errorMessage: false
    }
  },
  mounted () {
    if (this.name === 'state') {
      this.items.forEach((item) => [
        this.options.push(item.name)
      ])
    } else {
      this.options = this.items
    }
  },
  created () {
    if (this.required) {
      this.rules.push((value) => !!value || 'Required')
    }
    if (this.$attrs.value === 'Select') {
      this.rules.push((value) => !!value || 'Required')
    }
    if (this.$attrs.value === 'Select a State') {
      this.rules.push((value) => !!value || 'Required')
    }
  },
  methods: {
    selectOption (event) {
      const selected = event.target.value
      this.selectedOption = selected
      this.$emit('optionSelected', selected)

      // validate
      this.validate()
    },
    validate () {
      this.$nextTick(() => {
        this.showErrorMessage = !this.isValid()
        this.errorMessage = this.getErrorMessage()
      })
    },
    isValid () {
      const input = this.selectedOption
      if (!!input &&
          input !== null &&
          this.options.includes(input)
      ) {
        // check to see if it's a select value after input is checked for null/undefined
        const isSelect = input.toLowerCase().includes('select')
        if (isSelect) {
          return false
        }
        return true
      } else {
        return false
      }
    },
    getErrorMessage () {
      return 'REQUIRED'
    }
  }
}
</script>

<style lang="scss" scoped>
  .select-picker{
    width: 100%;
    height: 35px;
    border: 1px solid #007bbd;
    // padding-left: 10px;
    -webkit-appearance: auto;
  }

  .select-picker.is-error{
    border: red solid 1px;
  }

  .err-msg {
    color: #BB492E;
    font-size: 12px;
    padding-top: 5px;
    line-height: 12px;
  }
</style>
